// extracted by mini-css-extract-plugin
module.exports = {"default":"ServerLinkPrimary_default__lFYnK","inverse":"ServerLinkPrimary_inverse__ns05W"};